import { GoogleAuthProvider, signInWithPopup, signInWithRedirect } from 'firebase/auth';
import { auth } from '../backend/firebase';
import { persistor } from '../redux/store';

const provider = new GoogleAuthProvider();

/**
 * Google sign-in with the same popup→redirect fallback used by SignInButton /
 * SignInModal (handles popup blockers and iOS Safari). AuthProvider reacts to
 * the resulting auth state change.
 */
export async function signInWithGoogle(): Promise<void> {
    try {
        await signInWithPopup(auth, provider);
    } catch (err: any) {
        if (err?.code === 'auth/popup-blocked' || err?.code === 'auth/popup-closed-by-user') {
            await persistor.flush();
            await signInWithRedirect(auth, provider);
        } else {
            console.error('Sign-in error:', err);
        }
    }
}
